import React, { useRef, useEffect, useState } from 'react';
import Home from './Home';
import About from './About';
import Courses from './Courses';
import Contact from './Contact';
import logo from '../src/Images/solar-system.png';
import Footer from './Footer';
import ScrollToTopButton from './ScrolltoTop';
import Testimonials from './Testimonials';


function App() {
  const homeRef = useRef(null);
  const aboutRef = useRef(null);
  const coursesRef = useRef(null);
  const contactRef = useRef(null);
  const TestimonialsRef = useRef(null);
  const atBottomRef = useRef(false);
  const [showNav, setShowNav] = useState(true);
   const [showToast, setShowToast] = useState(false);
  const [toastMsg, setToastMsg] = useState('');
  const [toastType, setToastType] = useState('warning');

  const handleLoginClick = () => {
    // setToastMsg('Application under construction');
    // setToastType('warning');
    // setShowToast(true);
    // setTimeout(() => setShowToast(false), 5000);
     window.location.href = 'https://predict-astrolabs-front-endweb.vercel.app';
    
  }
  const scrollToSection = (ref) => {
    ref.current.scrollIntoView({ behavior: 'smooth' });
  };

  

  const [visibleSections, setVisibleSections] = useState([false, false, false, false]);
  // const sectionRefs = [homeRef, aboutRef, coursesRef, contactRef];

useEffect(() => {
  let lastScrollY = window.scrollY;
  
  const handleScroll = () => {
    const currentScrollY = window.scrollY;
    const windowHeight = window.innerHeight;
    const documentHeight = document.body.scrollHeight;
    console.log(currentScrollY, windowHeight, documentHeight);

    if (currentScrollY + windowHeight >= documentHeight - 50) {
      if (!showNav || !atBottomRef.current) {
        setShowNav(true);
        atBottomRef.current = true;
      }
    } else if (currentScrollY > lastScrollY && currentScrollY > 100) {
      if (showNav) setShowNav(false);
      atBottomRef.current = false;
    } else if (currentScrollY < lastScrollY) {
      if (!showNav) setShowNav(true);
      atBottomRef.current = false;
    }
    lastScrollY = currentScrollY;
  };

  window.addEventListener('scroll', handleScroll);
  return () => window.removeEventListener('scroll', handleScroll);
}, [showNav]);



  return (
    <div className="App">
      {showNav && (
        <nav
          style={{
            display: 'flex',
            alignItems: 'center',
            padding: '1rem',
            background: '#f8f010ff',
            color: '#030101ff',
            justifyContent: 'space-between',
            position: 'sticky',
            top: 0,
            left: 0,
            zIndex: 1000,
            boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <img
              src={logo}
              alt="AstroLabs-Logo"
              style={{ width: '32px', height: '32px', marginRight: '1rem' }}
            />
            <p style={{marginBottom:"0"}}>MyAstroLabs</p>
          </div>
          <div className='top-menu'>
            <button onClick={() => scrollToSection(homeRef)} style={{ margin: '0 1rem', background: 'none', border: 'none', color: '#030101ff', fontSize: '1rem', cursor: 'pointer' }}>Home</button>
            <button onClick={() => scrollToSection(aboutRef)} style={{ margin: '0 1rem', background: 'none', border: 'none', color: '#030101ff', fontSize: '1rem', cursor: 'pointer' }}>About Us</button>
            <button onClick={() => scrollToSection(coursesRef)} style={{ margin: '0 1rem', background: 'none', border: 'none', color: '#030101ff', fontSize: '1rem', cursor: 'pointer' }}>Courses</button>
            <button onClick={() => scrollToSection(contactRef)} style={{ margin: '0 1rem', background: 'none', border: 'none', color: '#030101ff', fontSize: '1rem', cursor: 'pointer' }}>Contact Us</button>
            <button  onClick={handleLoginClick} style={{ margin: '0 1rem', background: 'none', border: 'none', color: '#030101ff', fontSize: '1rem', cursor: 'pointer' }}>Application Login</button>
          </div>
        </nav>
      )}

      <div
  className={`toast align-items-center text-bg-${toastType} border-0${showToast ? ' show' : ''}`}
  role="alert"
  aria-live="assertive"
  aria-atomic="true"
  style={{
    position: 'fixed',
    top: 80,
    right: 30,
    minWidth: 250,
    zIndex: 2000,
    opacity: showToast ? 1 : 0,
    transition: 'opacity 0.5s'
  }}
>
  <div className="d-flex">
    <div className="toast-body">{toastMsg}</div>
    <button
      type="button"
      className="btn-close btn-close-white me-2 m-auto"
      aria-label="Close"
      onClick={() => setShowToast(false)}
    ></button>
  </div>
</div>

      <div className='astrolabs-website'>
        <section ref={homeRef} className={`fade-section${visibleSections[0] ? ' visible' : ''}`} style={{ height: '100vh' }}><Home /></section>
        <section ref={aboutRef} className={`fade-section${visibleSections[1] ? ' visible' : ''}`} style={{ height: 'auto' }}><About /></section>
        <section ref={coursesRef} className={`fade-section${visibleSections[2] ? ' visible' : ''}`} style={{ height: 'auto' }}><Courses   onLearnMore={() => scrollToSection(contactRef)}/></section>
        <section ref={TestimonialsRef} className={`fade-section${visibleSections[2] ? ' visible' : ''}`} style={{ height: 'auto' }}><Testimonials  onLearnMore={() => scrollToSection(contactRef)}/></section>

        <section ref={contactRef} className={`fade-section${visibleSections[3] ? ' visible' : ''}`} style={{ height: '100%' }}><Contact /></section>
    <ScrollToTopButton />
     <Footer />
      </div>
         
    </div>
  );
}

export default App;
